<template>
  <div class="pa-4">
    <div class="d-flex align-center mb-4">
      <span class="text-h6">CODECO API Tester</span>
    </div>

    <v-row>
      <v-col cols="12" md="9">
        <div class="mb-2 section-title">Gate Out</div>
        <RequestPanel v-model="gateOut" class="mb-6" />

        <div class="mb-2 section-title">Gate In</div>
        <RequestPanel v-model="gateIn" />
      </v-col>

      <v-col cols="12" md="3">
        <MasterDataPanel />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import RequestPanel from "./RequestPanel.vue";
import MasterDataPanel from "./MasterDataPanel.vue";
import {
  isAuthenticated,
  hasRouteAccess,
  getPermissions,
} from "@/utils/functions";

function samplePayload(eventType, extra = {}) {
  return JSON.stringify(
    {
      event_type: eventType,
      terminal: eventType === "gate_out" ? "KCT" : "SCT",
      data: [
        {
          container_number: "",
          container_type: "",
          origin: "",
          destination: "",
          driver_id: "",
          vehicle_no: "",
          vbs_reference_no: "",
          timestamp: "",
          ...extra,
        },
      ],
    },
    null,
    2
  );
}

export default {
  components: { RequestPanel, MasterDataPanel },
  data() {
    return {
      permissions: null,
      gateOut: {
        method: "POST",
        url: "/api/v1/codeco/gate_out/",
        apiKey: "",
        payloadText: samplePayload("gate_out"),
        payloadError: "",
        sending: false,
        response: { status: null, body: "", durationMs: null },
      },
      gateIn: {
        method: "POST",
        url: "/api/v1/codeco/gate_in/",
        apiKey: "",
        payloadText: samplePayload("gate_in", { voyage_id: "" }),
        payloadError: "",
        sending: false,
        response: { status: null, body: "", durationMs: null },
      },
    };
  },
  beforeMount() {
    if (!isAuthenticated()) {
      this.$router.push("/");
    } else if (!hasRouteAccess(this.$route)) {
      this.$router.push(`/${localStorage.getItem("user_type").toLowerCase()}`);
    } else {
      const permissions = getPermissions("emergency_order_container");
      if (!permissions || !permissions.view) {
        this.$bus.$emit("showToastMessage", {
          message: "You don't have access to this module!",
          color: "error",
        });
        this.$router.push(
          `/${localStorage.getItem("user_type").toLowerCase()}`
        );
      } else {
        this.permissions = { ...permissions };
      }
    }
  },
};
</script>

<style scoped>
.section-title {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.6);
}
</style>
